module.exports = __webpack_public_path__ + "img/flute.be5030ca.webp";